/**
 * Which product the shared app is being used as.
 *
 * The same `crm/index.html` is served at /crm/ (Hunts) and at /meet/
 * (the BookMe dashboard; `.github/workflows/deploy.yml` copies crm/ to
 * meet/). The path decides what the shell shows: BookMe opens on Calendar
 * and hides the Hunts screens until the user turns them on.
 */

export type Product = 'hunts' | 'bookme'

export function detectProduct(pathname: string): Product {
  return /^\/meet(\/|$)/.test(pathname) ? 'bookme' : 'hunts'
}

export function currentProduct(): Product {
  if (typeof location === 'undefined') return 'hunts'
  return detectProduct(location.pathname)
}

/** The BookMe two-minute setup (host onboarding wizard). */
export const BOOKME_ONBOARDING_URL = '/meet/onboarding/'

/** user_settings key: 'true' turns the Hunts screens on inside BookMe. */
export const SHOW_HUNTS_KEY = 'show_hunts'

/** The account that sees owner-only tools (Settings > Maintenance). */
export const OWNER_EMAIL = 'ent.shaun@gmail.com'

export function isAdmin(email: string | undefined | null, search: string): boolean {
  if (email && email.toLowerCase() === OWNER_EMAIL) return true
  try {
    return new URLSearchParams(search).get('admin') === '1'
  } catch {
    return false
  }
}
